import { breakpoints, spaces } from '@99designs/common/core/settings';
import Heading from 'common/components/Heading';
import { Currency, toUnit } from 'common/utils/currency';
import Stack from 'projects/libs/core-components/Stack/Stack';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

export interface Props {
    title: string;
    price: number;
    currency: Currency;
}

const Card = styled.div`
    width: 375px;
    padding: ${spaces.space8}px;
    border-radius: ${spaces.space4}px;
    box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.1);

    @media screen and (max-width: ${breakpoints.small[1]}px) {
        width: 100%;
        padding: ${spaces.space10}px;
    }
`;

const BriefPackage = ({ title, price, currency }: Props) => {
    return (
        <Card>
            <Stack space="space5">
                <Heading size={'h5'} margin={'no'}>
                    {title}
                </Heading>
                <FormattedNumber
                    value={toUnit(price, currency)}
                    currency={currency}
                    style="currency"
                />
            </Stack>
        </Card>
    );
};

export default BriefPackage;
